<template>
    <div>
        <div class="title">{{$translate('Previous match')}}</div>
        <div v-if="loading" class="d-flex align-center justify-center">
            <v-progress-circular size="20" indeterminate color="primary" width="2"></v-progress-circular>
        </div>
        <div v-else @click="goToMatch()" style="cursor: pointer;">
            <teamsport-match-result :match="match" :teamId="teamId" :showTeamNames="false" :showHomeAway="false" class="z-clickable" />
        </div>
    </div>
</template>

<script>
import TeamsportMatchResult from './TeamsportMatchResult.vue';
export default {
    name: 'zoezi-teamsport-previous-match',

    zoezi: {
        title: 'Previous match',
        icon: 'mdi-calendar-clock',
        addon: 'TeamSports'
    },

    props: {
        teamId: {
            title: 'Registration ID',
            type: Number
        }
    },

    components: {
        TeamsportMatchResult
    },

    data: () => ({
        match: null,
        loading: false,
        unsubscribe: []
    }),

    watch: {
        groupId: {
            immediate: true,
            handler() {
                this.getPreviousMatch();
            }
        },
        '$store.state.user'() {
            // This is to make sure the logo is updated when logo is changed from team settings (user.groups change)
            this.getPreviousMatch();
        }
    },

    methods: {
        goToMatch() {
            const matchPage = this.$root.siteconfig?.pages?.match;
            this.$root.followLink(matchPage, this.match.id);
        },
        getPreviousMatch() {
            this.loading = true;
            this.$api.get('/api/memberapi/teamsport/match/previous', {team_id: this.teamId}).then(match => {
                if (match?.length == 0) {
                    match = null;
                }
                this.match = match;
                this.loading = false;
            });
        }
    },
    mounted() {
        this.unsubscribe.push(this.$api.subscribe({type: 'teamsportmatch', callback: (_, event) => {
            if (this.match && event.data.find(x => x.id == this.match.id)) {
                this.getPreviousMatch();
            }
        }}))
    },
    destroyed() {
        this.unsubscribe.forEach(x => x());
    }
}
</script>
